/**
 * This build cannot host the sign-in.
 *
 * A browser page cannot read the url Spotify redirects to, so the web build
 * asks the artist to use the desktop or phone app instead.
 */
export class ArtistPortalAuthUnsupportedError extends Error {
  constructor(message = 'Artist portal sign-in is not supported on this platform') {
    super(message);
    this.name = 'ArtistPortalAuthUnsupportedError';
  }
}
